import { GridWithGapsNoCols } from '@dreamstack/feature-components/src/layout/MainGrid'
import { useTranslation } from '@dreamstack/i18n'
import { cn } from '@dreamstack/util/src/cn'
import React from 'react'

const BigGridFont = ({
  children,
  className,
}: React.PropsWithChildren<{ className?: string }>) => (
  <p
    className={cn(
      'text-px-20 leading-px-30 ml:text-px-48 ml:leading-px-60 font-semibold',
      className
    )}
  >
    {children}
  </p>
)

const SmallGridFont = ({
  children,
  className,
}: React.PropsWithChildren<{ className?: string }>) => (
  <p
    className={cn(
      'text-px-16 leading-px-24 font-normal mt-px-8 ml:font-semibold',
      className
    )}
  >
    {children}
  </p>
)

const GridEntry = ({
  children,
  className,
}: React.PropsWithChildren<{ className?: string }>) => (
  <div className={cn(className)}>{children}</div>
)

export const WerGridTable = () => {
  const t = useTranslation()
  return (
    <GridWithGapsNoCols
      className={cn(
        'grid-cols-2 mt-px-40 gap-y-px-24',
        'md:grid-cols-3 md:mt-px-80 md:gap-y-px-48',
        'lg:grid-cols-5 lg:mt-px-64'
      )}
    >
      <GridEntry>
        <BigGridFont>{t('accentro:werGridTable.years')}</BigGridFont>
        <SmallGridFont>
          {t('accentro:werGridTable.profoundKnowledge')}
        </SmallGridFont>
      </GridEntry>
      <GridEntry>
        <BigGridFont>80</BigGridFont>
        <SmallGridFont>{t('accentro:werGridTable.majorCities')}</SmallGridFont>
      </GridEntry>
      <GridEntry>
        <BigGridFont>85%</BigGridFont>
        <SmallGridFont>
          {t('accentro:werGridTable.ofGermanMarket')}
        </SmallGridFont>
      </GridEntry>
      <GridEntry>
        <BigGridFont>{t('accentro:werGridTable.safe')}</BigGridFont>
        <SmallGridFont>{t('accentro:werGridTable.dataBasedOn')}</SmallGridFont>
      </GridEntry>
      <GridEntry>
        <BigGridFont>{t('accentro:werGridTable.partner')}</BigGridFont>
        <SmallGridFont>
          {t('accentro:werGridTable.ofThe')} &ldquo;Institut der deutschen
          Wirtschaft&rdquo;
        </SmallGridFont>
      </GridEntry>
    </GridWithGapsNoCols>
  )
}
